module.exports = __webpack_public_path__ + "images/tips/info-image-01@2x.531a5b21fc678df0bfe9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-01@2x.png
// module id = o6ws
// module chunks = 13